/**
 * request.js 封装axios请求,并绑定在vue全局实例上
 * 
 * need_login： 是否需要登录权限，默认为true
 * url: 请求的API地址
 * params: 请求参数
 * headers: 请求头
 * 
 **/ 

import Vue from "vue"
import axios from 'axios'

const app = Vue.prototype;

export default {
    post({need_login = true,url = "",params = {},headers = {}}){
        // 需要登录时，从本地拿用户信息
        if(need_login){
            if(localStorage.users){
                headers.token = JSON.parse(localStorage.users).token;
                params.user_id = JSON.parse(localStorage.users).user_id;
            } else if(sessionStorage.getItem('users')){
                headers.token = JSON.parse(sessionStorage.getItem('users')).token;
                params.user_id = JSON.parse(sessionStorage.users).user_id;
            } else {
                app.$router.push("/login");
            }
        } 

        return new Promise((resolve,reject) => {
            axios.post(app.baseUrl + url,params,{headers: headers})
            // axios.post("/api" + url,params,{headers: headers})
            .then(res => {
                // console.log(res);
                
                // app.$nextTick(() => { 
                //     app.$loading().close();
                // });

                if(res.status == 200){
                    if(res.data.code == 200){
                        resolve(res.data);
                    } else {
                        app.$nextTick(() => { 
                            app.$loading().close();
                        });
                        app.$message({
                            message: res.data.msg? res.data.msg:"服务器繁忙",
                            type: 'warning'
                        })

                        reject();
                    }
                } else {
                    app.$nextTick(() => { 
                        app.$loading().close();
                    });
                    app.$message({
                        message: res.data.msg? res.data.msg:"服务器繁忙",
                        type: 'error'
                    });

                    reject();
                }
                
            },err => {
                console.log(err)
                app.$message({
                    message: "服务器繁忙",
                    type: 'error'
                });

                app.$nextTick(() => { 
                    app.$loading().close();
                });

                reject();
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/libs/api/request.js